import React from 'react';
import '../ListCollapse/ListCollapse.css';
import { Collapse, Button, CardBody, Card, ListGroup, ListGroupItem, Row, Col, Container } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/fontawesome-free-solid';
import BimeManager from '../../Core/BimeManager';
import Axios from 'axios';
import UserManager from '../../Core/UserManager';
import Config from '../../Core/Config.js';
import { framework, ui } from 'saffroncodejs';
var PageManager = framework.PageManager;

class Khesarat extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.redirect = this.redirect.bind(this);
        this.state = {
            collapse: false,
            items: [
                {
                    id: 0, btnText: 'باربری داخلی', collapse: true, itemsInItem: [
                        { itemInId: 0, startDate: '90/04/12', incidentDate: '97/01/12', NotifDate: '97/05/05', insuranceNumber: '95/03/99/99/3021840', TitleReshte: 'باربری داخلی', ReshteCode: '8', Moredekhesarat: '', soudor: '730', prvCodeSodurtext: 'شعبه شرق تهران', dmgmored: 'null', bimeshodeasli: 'null' },
                        { itemInId: 1, startDate: '90/04/12', incidentDate: '97/01/12', NotifDate: '97/05/05', insuranceNumber: '95/03/99/99/3021840', TitleReshte: 'باربری داخلی', ReshteCode: '8', Moredekhesarat: '', soudor: '730', prvCodeSodurtext: 'شعبه شرق تهران', dmgmored: 'null', bimeshodeasli: 'null' },
                        { itemInId: 2, startDate: '90/04/12', incidentDate: '97/01/12', NotifDate: '97/05/05', insuranceNumber: '95/03/99/99/3021840', TitleReshte: 'باربری داخلی', ReshteCode: '8', Moredekhesarat: '', soudor: '730', prvCodeSodurtext: 'شعبه شرق تهران', dmgmored: 'null', bimeshodeasli: 'null' },
                        { itemInId: 3, startDate: '90/04/12', incidentDate: '97/01/12', NotifDate: '97/05/05', insuranceNumber: '95/03/99/99/3021840', TitleReshte: 'باربری داخلی', ReshteCode: '8', Moredekhesarat: '', soudor: '730', prvCodeSodurtext: 'شعبه شرق تهران', dmgmored: 'null', bimeshodeasli: 'null' },
                    ]
                },

            ],
            isloading: true
        }
        this.state.items = [];
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Cmn/api/Person/LossRecords",

                { Codemelli: UserManager.MelliCode() }
            ),
            BimeManager.header())
            .then(this.ResultExport.bind(this))
            .catch((error) => { alert(error) })
    }

    ResultExport(respond) {

        var result = [
            { "PrvDate": "97/05/05", "HadeseDate": "1396/10/27", "ElamDate": "1395/10/27", "FullBNo": "95/03/3237/3237/3005350", "ReshteText": "باربری داخلی", "Reshte": 5, "DmgMoredText": "", "SodurBId": 4471221, "SodurPrvId": 730, "PrvCodeSodurText": "شعبه شرق تهران کد", "DmgMored": "null", "BimeShodeAsliCmnId": "null" },
        ]
        result = respond.data;
        //console.log(result);

        var i;
        /////////
        var items = [
            {
                id: 0, btnText: 'باربری داخلی', collapse: true, itemsInItem: [
                    { itemInId: 0, startDate: '90/04/12', incidentDate: '97/01/12', NotifDate: '97/05/05', insuranceNumber: '95/03/99/99/3021840', TitleReshte: 'باربری داخلی', Reshte: '8', Moredekhesarat: '', soudor: '730', prvCodeSodurtext: 'شعبه شرق تهران کد 91', dmgmored: 'null', bimeshodeasli: 'null' },
                ]
            }]


        var subGroupsListIds = [];
        items = [];
        for (i = 0; i < result.length; i++) {
            if (subGroupsListIds.indexOf(result[i].Reshte) === -1) {
                subGroupsListIds.push(result[i].Reshte);
                items.push({ id: result[i].Reshte, btnText: result[i].ReshteText, collapse: false, itemsInItem: [] });
            }
        }
        for (i = 0; i < items.length; i++) {
            for (var j = 0; j < result.length; j++) {
                if (items[i].id === result[j].Reshte) {
                    items[i].itemsInItem.push({ itemInId: result[j].SodurBId, ReshteCode: result[j].Reshte, startDate: result[j].PrvDate, incidentDate: result[j].HadeseDate, NotifDate: result[j].ElamDate, insuranceNumber: result[j].FullBNo, TitleReshte: result[j].ReshteText, Moredekhesarat: result[j].DmgMoredText, soudor: result[j].SodurPrvId, prvCodeSodurtext: result[j].PrvCodeSodurText, dmgmored: result[j].DmgMored, bimeshodeasli: result[j].BimeShodeAsliCmnId });
                    // items[i].itemsInItem.push({itemInId: result[j].SodurId, code:result[j].SodurId, name:'zohreh', startDate:result[j].BeginDate, endDate:result[j].EndDate, insuranceNumber:result[j].FullBNo});
                }
            }

        }
        this.setState({ items: items, isloading: false });
        // console.log('items',items);
        this.setState({ items: items });

    }


    toggle(num) {

        var listitems = this.state.items;
        /*for(var i = 0 ;i<listitems.length ; i++)
        {
            if(listitems[i].id === num)
            {
                listitems[i].collapse = !listitems[i].collapse ;
                break ;
            }
        }*/
        var p = listitems.find(x => x.id === num);
        p.collapse = !p.collapse;
        this.setState({ items: listitems });
    }
    pagechange(SodurID, dmgmoredd, bimeshodeasli, reshteInput) {
        // switch (reshteInput) {

        //case 17:

        if (bimeshodeasli === 0) {

            bimeshodeasli = null
        }
        if (dmgmoredd === undefined) {

            dmgmoredd = null
        }
        PageManager.changePage(Config.p_havalekhesarat, [SodurID, dmgmoredd, bimeshodeasli, reshteInput]);
        //  break;

        //}
    }





    redirect(btnItem, id) {
        return ('/Detail')
    }
    render() {
        const items = this.state.items;
        console.log('items2*', items);
        //var num = 0;
        if (this.state.isloading === true) {

            return (
                <div className="collapse-list container">
                    <Row>
                        <Col sm="12" className="alignRight title">
                            <h4>خسارتهای من</h4>
                        </Col>
                    </Row>
                    <ui.Preloader />

                </div>
            )
        }
        return (
            <div className="collapse-list container">

                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>خسارت های من</h4>
                    </Col>
                </Row>
                {items.length !== 0 ? items.map((item) => (
                    <div key={item.id} >
                        <Button color="collapse" onClick={() => { this.toggle(item.id) }}> <FontAwesomeIcon icon={faAngleDown} />&nbsp;{item.btnText} </Button>
                        <Collapse isOpen={item.collapse}>
                            <Card>
                                <CardBody>
                                    <ListGroup>
                                        {item.itemsInItem.map((itemIn) => (
                                            <div onClick={() => {

                                                // BimeManager.resh=itemIn.

                                                this.pagechange(itemIn.soudor, itemIn.dmgmored, itemIn.bimeshodeasli, item.id);
                                                //alert('showww*****'+itemIn.code)

                                            }}>

                                                <ListGroupItem >
                                                    <Container>
                                                        <Row >
                                                            <Col sm="12" className="alignRight"><span> شماره بیمه نامه:</span><span className="date-format">{itemIn.insuranceNumber}</span> </Col>

                                                            <Col sm="6" className="alignRight"> <span> تاریخ تشکیل پرونده:</span><span className="date-format">{itemIn.startDate}</span> </Col>
                                                            <Col sm="12" className="alignRight"> <span>تاریخ حادثه:</span><span className="date-format">{itemIn.incidentDate}</span> </Col>
                                                            <Col sm="12" className="alignRight"> <span>تاریخ اعلام:</span><span className="date-format">{itemIn.NotifDate}</span> </Col>
                                                            <Col sm="12" className="alignRight"> <span>عنوان رشته:</span><span className="date-format">{itemIn.TitleReshte}</span> </Col>
                                                            <Col sm="12" className="alignRight"> <span>کد رایانه پرونده خسارت:</span><span className="date-format">{itemIn.soudor}</span> </Col>
                                                            <Col sm="12" className="alignRight"> <span>مورد خسارت:</span><span className="date-format">{itemIn.Moredekhesarat}</span> </Col>
                                                            <Col sm="12" className="alignCenter"> <span></span><span className="date-format">{itemIn.prvCodeSodurtext}</span> </Col>
                                                        </Row>
                                                    </Container>
                                                </ListGroupItem>

                                            </div>
                                        ))
                                        }
                                    </ListGroup>
                                </CardBody>
                            </Card>
                        </Collapse>
                    </div>
                )) : <ListGroup>
                        <ListGroupItem >
                            <Container>
                                <Row >
                                    <Col sm="12" className="alignCenter">
                                        <span>
                                            لیست خسارتهای شما خالی است
                                        </span>
                                    </Col>
                                </Row>
                            </Container>
                        </ListGroupItem>
                    </ListGroup>
                }
            </div>
        );
    }
}

export default Khesarat;



// WEBPACK FOOTER //
// ./src/components/Khesarat/Khesarat.js